<template>
  <div class="hello">
    <Header></Header>

    <div class="content_s clearfix">
      <el-row>
        <el-col>
          <div class="listyyy clearfix">

            <div class="listyyy-l" v-if="person_info != ''">
            <div  class="tx-img">
             <img :src="person_info[0].avatar_url" alt="touxiang">
             </div>
             <span class="yyy-name">{{person_info[0].name}}</span>
             <span class="yyy-intro">{{person_info[0].intruduce}}</span>
            </div>

            <div class="listyyy-r">
              <div class="listyyy-item">
                <el-tabs v-model="chanals_Data" >
                  <el-tab-pane v-for="(au,index) in chanalsData" :key="index" :label="au.name" :name="au.prop_tra"></el-tab-pane>
                </el-tabs>
              </div>
              <el-row v-if="person_info[1].length > 0">

                <el-col v-for="(val, index) in person_info[1]" :key="index">
                  <el-card :body-style="{ padding: '0px'}">
                    <div class="video-pic">
					            <img :src="val.thumb_image_url" class="img">
                    </div>
                    <div class="shake" @click="redirect_to_artical(val._uniquecode)">                      
                      <a href="">
                      <h3>{{val.title}}</h3>
                      <p>{{val.summary}}</p>
                      </a>
                     <span>{{val.public_time}}</span>
                    </div>
                  </el-card>
                </el-col>
                
              </el-row>
              <el-row v-else>
                <el-empty    description="暂无内容"></el-empty>
              </el-row>
          
              <!-- <el-button type="primary"
                         @click="openFullScreen1"
                         v-loading.fullscreen.lock="fullscreenLoading">
                加载更多
              </el-button> -->
            </div>
           
            
          </div>


        </el-col>
      </el-row>
    </div>



    <bbottom></bbottom>

  </div>

</template>
<script>

  import Header from "@/components/public/Header.vue"
  import bbottom from "@/components/public/bbottom.vue"
  export default {
   name: 'ResearchDetail',

    data() {
      return {
        chanalsData: [
          { name: 'TA的文章', prop_tra: '2022' },
        ],
        chanals_Data:'',
        person_info:[],

      }
    },

    props: {},

    //页面初始化
    computed: {

    },
    created(){
      this.get_person_info()
    },

    //页面加载后执行方法
    methods: {
      redirect_to_artical(research_unique){
        this.$router.push({path:'/article/'+research_unique})
      },
      get_person_info(){
        var config = {
          method: 'GET',
          url: '/api/v1/researcher/person/detail/'+this.$route.params.researcher_uniqueid,
          headers: {
            'Content-Type': 'application/json'
          }
        };
            
        this.$axios(config).then(res=>{
          this.person_info = res.data
        }).catch(error=>{
          console.log('请求失败')
        })

      },

    },
    //组件引入
    components: {

      Header,
      bbottom
    },
  }

</script>
<style scoped>

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .content_s {
    width: 1200px;
    margin: 25px auto;
    color: #4b4b4b;
  }

  .img_s {
    width: 100%;
    border-radius: 6px;
  }

  .top {
    width: 1200px;
    margin: 0 auto;
  }

    .top img {
      display: block
    }

  .all-yyy {
    position: fixed;
    top: 0;
    left: 0;
    margin: auto;
    width: 100%;
    height: 100%;
    z-index: 1000;
    overflow: hidden;
  }

  .yyy-mask {
    width: 100%;
    height: 100%;
    background: #f9f9f9;
    opacity: 0.98;
    overflow: auto;
    transition: opacity 1s ease 0s;
  }

  .opacity0 {
    opacity: 0;
  }

  .opacity1 {
    opacity: 1;
  }

  .yyy-mask-contant {
    width: 1200px;
    margin: auto;
  }

  .yyy-mask-header {
    padding-top: 66px;
  }

  .logo {
    width: 223px;
    display: block;
    float: left;
    height: 52px;
  }

  .yyy-mask-header .close {
    width: 24px;
    height: 24px;
    float: right;
    position: relative;
    top: 20px;
    cursor: pointer;
  }

  .yyy-item {
    width: 1000px;
    margin: 0px auto;
  }
  .listyyy-item {
    margin:20px 20px 0px 0px;
    background-color:#fff;

  }
   
    .listyyy {
      width: 1000px;
      margin: 0 auto;
      background-color: #f9f9f9;
      padding-bottom:20px ;
    }
  .listyyy-l {
    width: 280px;
    float: left;
    padding:20px;
    height:100%;
    background-color:#fff;
    box-sizing:border-box;
    margin:20px;
  }
  .listyyy-r {
    width: 680px;
    float: left;
    box-sizing:border-box;
  }


    .listyyy-r .el-card {
      transition: 3s;
      margin: 20px 20px 0px 0px;
      padding:20px;
      box-sizing:border-box;
      border:none;
      background-color:#fff;
    }
      .listyyy-r .el-card.is-always-shadow {
        -webkit-box-shadow: none;
        box-shadow: none;
      }
  .video-pic {
    width: 150px;
    float: left;
    position: relative;
    
    overflow: hidden;
    margin-right: 20px;
  }

    .video-pic img {
      width: 150px;
      display: block;
      float: left;
      transition: all 1s ease 0s;
    }

   

  .shake {
    width: 410px;
    float: left;
    position: relative;
    height:100px;
    
  }

  .video-pic:hover .img {
    cursor: pointer;
    transform: scale(1.2);
  }

  .el-card h3 {
    margin: 0px 0px 10px;
    padding: 0px;
    font-size: 16px;
    line-height: 24px;
    overflow: hidden;
    font-weight:normal;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    min-height: 24px;
  }

  .el-card p {
    font-size: 14px;
    line-height: 20px;
    margin: 0px;
    padding: 0px;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    height:40px;
    overflow:hidden;
  }

  .el-card span {
    margin: 0px;
    padding: 0px;
    font-size: 12px;
    line-height: 18px;
    color: #999;
    display: block;
    position: absolute;
    left: 0px;
    bottom: 0px;
  }


  .el-button--primary {
    background-color: #ffffff;
    border: 1px solid #f9f9f9;
    font-size: 18px;
    color: #999;
    display: block;
    margin: 35px auto;
  }

  .kx-yyy {
    width: 100%;
    padding: 25px;
    -webkit-box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    margin: 10px auto;
  }

    .kx-yyy h3 {
      margin: 0px;
      padding: 0px 0px 10px;
      font-size: 20px;
      line-height: 28px;
    }

  .listyyy a {
    color: #4b4b4b;
    text-decoration: none;
  }

    .listyyy a:hover h3 {
     color: #bd0c16;
    }

  .kx-yyy p {
    font-size: 14px;
    line-height: 20px;
    margin: 0px;
    padding: 0px;
  }

  .kx-yyy span {
    margin: 0px;
    padding: 10px 0px 0px;
    font-size: 12px;
    line-height: 18px;
    color: #999;
    display: block;
  }

  .kx-yyy em {
    font-weight: bold;
    font-style: normal;
    color: #bd0c16;
  }

  .listyyy-nodata {
    width: 830px;
    padding: 40px 25px;
    -webkit-box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    text-align: center;
    font-size: 16px;
    line-height: 24px;
  }
  .tx-img{
    
    border:1px solid #ccc; 
   display:block;
    margin:0 auto;
    width:100px;
    height: 100px;
    border-radius:1000px;
    overflow: hidden;
  }
  .tx-img img{
    width: 150%;
    position: relative;
    left:-20px;
    top:0px;
  }
  .yyy-name {
    display: block;
    width: 100%;
    margin-top: 10px;
    font-size: 18px;
    line-height: 26px;
    font-weight: 500;
    text-align: center;
  }
.yyy-intro {
    display: block;
    width:100%;
    margin-top: 10px;
    color: #999;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: normal;
    line-height: 21px;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/ResearchDetail.vue